/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { ReviewerDetails } from 'pages/open-course/peerReview/components/types';

import ProfileImageCA from 'bundles/compound-assessments/components/shared/ProfileImageCA';

import _t from 'i18n!nls/ondemand';

const styles = {
  container: () => css`
    display: flex;
    margin-top: var(--cds-spacing-50);
  `,
};

type Props = {
  learners: ReviewerDetails[];
};

const HorizontalLearnerPhotos = ({ learners }: Props) => {
  return (
    <div css={styles.container}>
      {learners.map((learner, index) => (
        <ProfileImageCA
          // eslint-disable-next-line react/no-array-index-key
          key={`profile-image-${index}`}
          profile={{
            fullName: learner.fullName,
            photoUrl: learner.isDefaultPhoto ? undefined : learner.photoUrl,
            isAnonymous: learner.isAnonymous,
          }}
          alt={_t('Photo of learner #{learnerName}', { learnerName: learner.fullName })}
        />
      ))}
    </div>
  );
};

export default HorizontalLearnerPhotos;
